import API from '@/API/request';

export const approvalCenterApi = {
  // 获取费用列表
  getCostList: (params) => API.get(`/approvecenter/wait_tasks_cost/${params}`),
  // 获取代办数量
  getPendingQuantity: () => API.get(`/approvecenter/wait_tasks_count`),
  // 获取合规申请查看权限
  getComplianceShowPrivilege: () => API.get(`/compliance/approve/show_privilege`)
};
